// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13xNh","right":"styles_right__Q5ki2"};